export enum Parameter {
  HeartRate = 'HeartRate',
  OxygenSaturation = 'OxygenSaturation',
  OxygenSaturationSPO2 = 'OxygenSaturationSPO2',
  RespiratoryRate = 'RespiratoryRate',
  Hemoglobin = 'Hemoglobin',
  GFR = 'GFR',
  SystolicArterialPressure = 'SystolicArterialPressure',
  DiastolicArterialPressure = 'DiastolicArterialPressure',
  MeanArterialPressure = 'MeanArterialPressure',
  SystolicBloodPressure = 'SystolicBloodPressure',
  DiastolicBloodPressure = 'DiastolicBloodPressure',
  MeanBloodPressure = 'MeanBloodPressure',
  Potassium = 'Potassium',
  Temperature = 'Temperature',
  InvasiveBloodPressure = 'InvasiveBloodPressure',
  NonInvasiveBloodPressure = 'NonInvasiveBloodPressure',
  MortalityRate = 'MortalityRate',
  BloodPressure = 'BloodPressure',
  AnionGap = 'AnionGap',
  BaseExcess = 'BaseExcess',
  Bicarbonate = 'Bicarbonate',
  Calcium = 'Calcium',
  Chloride = 'Chloride',
  DefaultBicarbonate = 'DefaultBicarbonate',
  Carboxyhemoglobin = 'Carboxyhemoglobin',
  DeoxygenatedHemoglobinHHB = 'DeoxygenatedHemoglobinHHB',
  DeoxygenatedHemoglobinFHHB = 'DeoxygenatedHemoglobinFHHB',
  Methemoglobin = 'Methemoglobin',
  Oxyhemoglobin = 'Oxyhemoglobin',
  Glucose = 'Glucose',
  Sodium = 'Sodium',
  PartialPressurePCO2 = 'PartialPressurePCO2',
  PartialPressurePO2 = 'PartialPressurePO2',
  PackedCellVolume = 'PackedCellVolume',
  OxygenSaturationSO2 = 'OxygenSaturationSO2',
  TotalHemoglobin = 'TotalHemoglobin',
  Alat = 'Alat',
  Albumin = 'Albumin',
  AlkalinePhosphatase = 'AlkalinePhosphatase',
  Asat = 'Asat',
  AntithrombinIIIActivity = 'AntithrombinIIIActivity',
  Basophilgranulocyte = 'Basophilgranulocyte',
  Bilirubin = 'Bilirubin',
  BilirubinOverall = 'BilirubinOverall',
  CreatineKinase = 'CreatineKinase',
  CK_MB = 'CK_MB',
  Creatinine = 'Creatinine',
  Crp = 'Crp',
  EosinophilGranulocyte = 'EosinophilGranulocyte',
  Erythrocyte = 'Erythrocyte',
  Ferritin = 'Ferritin',
  GGT = 'GGT',
  Urea = 'Urea',
  UO = 'UO',
  UreaNitrogen = 'UreaNitrogen',
  HBA1C = 'HBA1C',
  Hco3std = 'Hco3std',
  Hematocrit = 'Hematocrit',
  Interleukin6 = 'Interleukin6',
  INR = 'INR',
  LDH = 'LDH',
  Leukocyte = 'Leukocyte',
  Lipase = 'Lipase',
  Lymphocyte = 'Lymphocyte',
  Mch = 'Mch',
  Mchc = 'Mchc',
  Mcv = 'Mcv',
  Magnesium = 'Magnesium',
  Monocyte = 'Monocyte',
  NeutrophilGranulocytes = 'NeutrophilGranulocytes',
  Procalcitonin = 'Procalcitonin',
  PartialThromboplastinTime = 'PartialThromboplastinTime',
  Quick = 'Quick',
  Lactate = 'Lactate',
  SerumLactate = 'SerumLactate',
  Thrombocytes = 'Thrombocytes',
  TotalProtein = 'TotalProtein',
  Triglycerides = 'Triglycerides',
  Troponin = 'Troponin',
  TroponinI = 'TroponinI',
  TroponinThs = 'TroponinThs',
  TSH = 'TSH',
  RDW = 'RDW',
  PH = 'PH'
}
